
export const userData = [
    {
        id: 1,
        year: 2016,
        userGain: 8000,
        userLoss: 8234
    },
    {
        id: 2,
        year: 2017,
        userGain: 45211,
        userLoss: 3459
    },
    {
        id: 3,
        year: 2018,
        userGain: 78888,
        userLoss: 5451
    },
    {
        id: 4,
        year: 2019,
        userGain: 92140,
        userLoss: 7410
    },
    {
        id: 5,
        year: 2020,
        userGain: 100248,
        userLoss: 12400
    },
];
